

// import { useVideoUploadHub } from "../DataService/BunnyHubService";
// import { Progress } from "./Progress";
// // import { FileVideo, CheckCircle2, AlertCircle, Loader2 } from "lucide-react";
// // import { cn } from "@/lib/utils";

// interface FileUploadItemProps {
//   file: File;
//   uploadId: string;
// }

// export const FileUploadItem = ({ file, uploadId }: FileUploadItemProps) => {
//   const uploadStatus = useVideoUploadHub(uploadId);

//   const getStatusIcon = () => {
//     if (!uploadStatus) {
//         return <>LOADERICON</>
//     //   return <Loader2 className="h-5 w-5 text-muted-foreground animate-spin" />;
//     }

//     switch (uploadStatus.status?.toLowerCase()) {
//       case 'completed':
//       case 'complete':
//         return <>CHECKCIRKLE</>
//         // return <CheckCircle2 className="h-5 w-5 text-success" />;
//       case 'error':
//       case 'failed':
//         return <>ALERTCIRCLE</>//return <AlertCircle className="h-5 w-5 text-destructive" />;
//       default:
//         return <>LOADER</>//return <Loader2 className="h-5 w-5 text-primary animate-spin" />;
//     }
//   };

//   const getStatusText = () => {
//     if (!uploadStatus) return 'Förbereder...';
    
//     switch (uploadStatus.status?.toLowerCase()) {
//       case 'completed':
//       case 'complete':
//         return 'Klar!';
//       case 'error':
//       case 'failed':
//         return uploadStatus.error || 'Fel uppstod';
//       default:
//         return `Laddar upp... ${Math.round(uploadStatus.progress || 0)}%`;
//     }
//   };

//   const progress = uploadStatus?.progress || 0;
//   const isComplete = uploadStatus?.status?.toLowerCase() === 'completed' || uploadStatus?.status?.toLowerCase() === 'complete';
//   const isError = uploadStatus?.status?.toLowerCase() === 'error' || uploadStatus?.status?.toLowerCase() === 'failed';

//   return (
//     <div className={`rounded-lg border bg-card p-4 transition-all duration-300 ${isComplete && "border-success/50 bg-success/5"} ${isError && "border-destructive/50 bg-destructive/5"}`
//      }>
//       <div className="flex items-start gap-3">
//         <div className={`rounded-md p-2 transition-colors ${isComplete ? "bg-success/10" : isError ? "bg-destructive/10" : "bg-primary/10"}`
//          }>
//           {/* <FileVideo className={cn(
//             "h-5 w-5",
//             isComplete ? "text-success" : isError ? "text-destructive" : "text-primary"
//           )} /> */}
//           FILEVIDEOICON
//         </div>
        
//         <div className="flex-1 min-w-0">
//           <div className="flex items-center justify-between gap-2 mb-2">
//             <p className="text-sm font-medium truncate text-foreground">
//               {file.name}
//             </p>
//             {getStatusIcon()}
//           </div>
          
//           <Progress 
//             value={progress} 
//             className="h-2 mb-2"
//           />
          
//           <div className="flex items-center justify-between text-xs">
//             <span className={`font-medium ${isComplete ? "text-success" : isError ? "text-destructive" : "text-muted-foreground"}`
//              }>
//               {getStatusText()}
//             </span>
//             <span className="text-muted-foreground">
//               {(file.size / (1024 * 1024)).toFixed(2)} MB
//             </span>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };
// File: src/Components/FileUploadItem.tsx

import React, { useEffect, useRef } from "react";
import { useVideoUploadHub } from "../DataService/BunnyHubService";
import { Progress } from "./Progress";

// You can later pass videoDto into this if you want to display title, duration, etc.
interface FileUploadItemProps {
  file: File;
  uploadId: string;
  onComplete?: (uploadId: string, file: File, kind?: string) => void;
}

export const FileUploadItem: React.FC<FileUploadItemProps> = ({ file, uploadId, onComplete }) => {
  const uploadStatus = useVideoUploadHub(uploadId);
  const didNotifyComplete = useRef(false);

  /* ---------------------------------------------------------
     ICON HANDLING
     Replace LOADER / CHECKCIRCLE / ALERTCIRCLE with your icons
  ------------------------------------------------------------*/
  const getStatusIcon = () => {
    if (!uploadStatus) return <>LOADER</>;

    const status = uploadStatus.status?.toLowerCase();

    if (status === "completed" || status === "complete") {
      return <>CHECKCIRCLE</>;
    }
    if (status === "error" || status === "failed") {
      return <>ALERTCIRCLE</>;
    }
    return <>LOADER</>;
  };

  /* ---------------------------------------------------------
     TEXT HANDLING
  ------------------------------------------------------------*/
  const getStatusText = () => {
    if (!uploadStatus) return "Förbereder...";

    const status = uploadStatus.status?.toLowerCase();

    switch (status) {
      case "completed":
      case "complete":
        return "Klar!";
      case "error":
      case "failed":
        return uploadStatus.error || "Fel uppstod";
      default:
        return `Laddar upp... ${Math.round(uploadStatus.progress || 0)}%`;
    }
  };

  /* ---------------------------------------------------------
     UI STATE FLAGS
  ------------------------------------------------------------*/
  const progress = uploadStatus?.progress ?? 0;

  const isComplete =
    uploadStatus?.status?.toLowerCase() === "completed" ||
    uploadStatus?.status?.toLowerCase() === "complete";

  const isError =
    uploadStatus?.status?.toLowerCase() === "error" ||
    uploadStatus?.status?.toLowerCase() === "failed";

  useEffect(() => {
    if (didNotifyComplete.current) return;

    if (isComplete || progress >= 100) {
      didNotifyComplete.current = true;
      onComplete?.(uploadId, file, file.type.startsWith("video") ? "video" : "dokument");
    }
  }, [file, isComplete, onComplete, progress, uploadId]);

  /* ---------------------------------------------------------
     RENDER
  ------------------------------------------------------------*/
  return (
    <div
      className={`rounded-lg border bg-card p-4 transition-all duration-300
      ${isComplete ? "border-success/50 bg-success/5" : ""}
      ${isError ? "border-destructive/50 bg-destructive/5" : ""}`}
    >
      <div className="flex items-start gap-3">
        {/* FILE ICON */}
        <div
          className={`
            rounded-md p-2 transition-colors 
            ${isComplete ? "bg-success/10" : ""}
            ${isError ? "bg-destructive/10" : ""}
            ${!isComplete && !isError ? "bg-primary/10" : ""}
          `}
        >
          FILEVIDEOICON
        </div>

        {/* MAIN CONTENT */}
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between gap-2 mb-2">
            <p className="text-sm font-medium truncate text-foreground">{file.name}</p>
            {getStatusIcon()}
          </div>

          {/* PROGRESS BAR */}
          <Progress value={progress} className="h-2 mb-2" />

          <div className="flex items-center justify-between text-xs">
            <span
              className={`font-medium
                ${isComplete ? "text-success" : ""}
                ${isError ? "text-destructive" : ""}
                ${!isComplete && !isError ? "text-muted-foreground" : ""}`}
            >
              {getStatusText()}
            </span>

            <span className="text-muted-foreground">
              {(file.size / (1024 * 1024)).toFixed(2)} MB
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
